import { Image } from '@/types/image.type';
import { Video } from '@/types/video.type';

export const isVideo = (item: Image | Video): item is Video =>
  item.src.endsWith('.mp4') || item.src.endsWith('.webm') || item.src.endsWith('.mov');
